import { Combobox, SelectMenuOptionContent } from '@customerio/pluma-components/react';
import type { ValueOption } from './types';

type MaskedValueOptionProps = {
  option: ValueOption;
  isSelected?: boolean;
  isActive?: boolean;
};

/**
 * The autosuggest options are the workspace's real stored attribute values —
 * subscriber PII for fields like email or phone. The combobox popover portals
 * to document.body, outside the input's own fs-mask, so each option masks
 * itself to keep the values out of FullStory session replay (FPS-3714).
 */
function MaskedValueOption(props: MaskedValueOptionProps) {
  return <SelectMenuOptionContent {...props} className="fs-mask" />;
}

export type ValueComboboxProps = {
  ariaLabel: string;
  testId?: string;
  disabled?: boolean;
  inputValue: string | null;
  isLoadingValueOptions?: boolean;
  placeholder?: string;
  valueOptions: ValueOption[];
  error?: string;
  onValueChange: (value: string) => void;
  onBlur?: () => void;
};

/** A free-text value with autosuggest, masked in session replay. */
export function ValueCombobox({
  ariaLabel,
  testId,
  disabled,
  inputValue,
  isLoadingValueOptions,
  placeholder = 'Value',
  valueOptions,
  error,
  onValueChange,
  onBlur,
}: ValueComboboxProps) {
  return (
    <Combobox
      data-testid={testId}
      ariaLabel={ariaLabel}
      className="fs-mask"
      size="sm"
      placeholder={placeholder}
      inputValue={inputValue ?? ''}
      onValueChange={onValueChange}
      onBlur={onBlur}
      options={valueOptions}
      optionComponent={MaskedValueOption}
      isLoading={isLoadingValueOptions}
      error={error}
      isDisabled={disabled}
      flexGrow="1"
      withVirtualizer
    />
  );
}
